import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Uniform label/hint/error shell around a form control.
 *
 *   <app-field-shell [label]="'Title'" [for]="id" [required]="true" [errorMessage]="errorKey">
 *     <input class="mty-native-input" ... />
 *   </app-field-shell>
 *
 * Keeps every field in the form — native or wrapped Material — visually
 * consistent: Lexend eyebrow label above, hint or error below.
 */
@Component({
  selector: 'app-field-shell',
  standalone: true,
  imports: [MatIconModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-col gap-1.5">
      @if (label()) {
        <label
          [attr.for]="for() || null"
          class="font-alternate text-[12px] font-semibold tracking-wider uppercase text-black/55">
          {{ label() | translate }}
          @if (required()) { <span class="text-mty-danger ml-0.5">*</span> }
        </label>
      }
      <ng-content></ng-content>
      @if (hint() && !errorMessage()) {
        <span class="font-base text-[12px] text-black/55">{{ hint() | translate }}</span>
      }
      @if (errorMessage()) {
        <span class="font-base text-[12px] text-mty-danger inline-flex items-center gap-1">
          <mat-icon style="font-size:14px;width:14px;height:14px">error_outline</mat-icon>
          {{ errorMessage() | translate }}
        </span>
      }
    </div>
  `,
})
export class FieldShellComponent {
  readonly label = input<string>('');
  readonly for = input<string>('');
  readonly required = input(false);
  readonly hint = input<string>('');
  readonly errorMessage = input<string>('');
}
